// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__UV-rZ","header":"PatientQuestionnaire_header__NmEZs","info":"PatientQuestionnaire_info__2JmL0"};